import { render, staticRenderFns } from "./DashboardAX.vue?vue&type=template&id=75bc76c4"
import script from "./DashboardAX.vue?vue&type=script&lang=js"
export * from "./DashboardAX.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports